import { createContext, use } from 'react'

export interface SearchContextType {
  isSearchFocused: boolean
  setIsSearchFocused: React.Dispatch<React.SetStateAction<boolean>>
}

export const SearchContext = createContext<SearchContextType | null>(null)

export const useSearchContext = (): SearchContextType => {
  const context = use(SearchContext)

  if (!context) {
    throw new Error('useSearchContext must be used within the SearchProvider')
  }

  return context
}
